import {
  AddressField,
  CityField,
  CountryCodeField,
  CreditCardNumberField,
  CvvField,
  EmailField,
  ExpirationField,
  FirstNameField,
  LastNameField,
  NameOnCardField,
  SaveCardOnFileField,
  StateField,
  ZipField,
} from '@src/clients/financialSettings/fields/CreditCardFields';
import { CurrencyField } from '@src/clients/financialSettings/fields/CurrencyFields';
import { CreditCardField } from '@src/orders/fields/CreditCardRelatedFields';
import { AmountField } from '@src/orders/fields/PreauthorizePaymentFields';
import * as yup from 'yup';

export const PreauthorizationInputsSchema = ({
  useSingleUseCard,
}: {
  useSingleUseCard: boolean;
}) => {
  if (useSingleUseCard) return SingleUseCardInputsSchema;
  return ExistingCardInputsSchema;
};

const SingleUseCardInputsSchema = yup
  .object()
  .shape({
    //Note: The credit card and its details sensitive details
    // (CVV, expiration, number) are handled by Nuvei
    [AmountField.fieldName]: AmountField.validator,
    [CurrencyField.fieldName]: CurrencyField.validator,
    [NameOnCardField.fieldName]: NameOnCardField.validator,
    [EmailField.fieldName]: EmailField.validator,
    [FirstNameField.fieldName]: FirstNameField.validator,
    [LastNameField.fieldName]: LastNameField.validator,
    [AddressField.fieldName]: AddressField.validator,
    [ZipField.fieldName]: ZipField.validator,
    [CityField.fieldName]: CityField.validator,
    [CountryCodeField.fieldName]: CountryCodeField.validator,
    [StateField.fieldName]: StateField.validator,
    [SaveCardOnFileField.fieldName]: SaveCardOnFileField.validator,
  })
  .required();

const ExistingCardInputsSchema = yup
  .object()
  .shape({
    [AmountField.fieldName]: AmountField.validator,
    [CurrencyField.fieldName]: CurrencyField.validator,
    [CreditCardField.fieldName]: CreditCardField.validator,
    [CvvField.fieldName]: yup.string(),
    [CreditCardNumberField.fieldName]: yup.string(),
    [ExpirationField.fieldName]: yup.string(),
    [NameOnCardField.fieldName]: yup.string(),
    [EmailField.fieldName]: yup.string(),
    [FirstNameField.fieldName]: yup.string(),
    [LastNameField.fieldName]: yup.string(),
    [AddressField.fieldName]: yup.string(),
    [ZipField.fieldName]: yup.string(),
    [CityField.fieldName]: yup.string(),
    [CountryCodeField.fieldName]: yup.string(),
    [StateField.fieldName]: yup.string(),
    [SaveCardOnFileField.fieldName]: SaveCardOnFileField.validator,
  })
  .required();
